import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledTd = styled.td`
  padding: 122px 0;
`;

const StyledSpinner = styled(Spin)`
  margin: 0 auto;
  width: 100%;
`;

export const TableLoading = ({ colSpan, ...props }) => (
  <tbody {...props}>
    <tr key="table-loading-row-1">
      <StyledTd colSpan={colSpan} className="chromatic-ignore">
        <StyledSpinner />
      </StyledTd>
    </tr>
  </tbody>
);

TableLoading.propTypes = {
  colSpan: PropTypes.number.isRequired,
};
